import { createRouter, createWebHashHistory } from 'vue-router'
import {useStore} from 'vuex'
import { inject } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus'
import { apiGetUserInfo } from '@/api/home'

import mysql from '../views/index/index'
import hostIndex from '../views/index/index'
import hostDetail from '../views/index/detail'
import delay from '../views/index/delay'
import upgrade from '../views/index/upgrade'
import users from '../views/users/index'
import warning from '../views/warning/index'
import backup from '../views/backup/index'
import lists from '../views/lists/index'
import welcome from '../views/index/welcome'
import config from '../views/config/index'
import template from '../views/template/index'
import templateDetail from '../views/template/detail'
import log from '../views/log/index'
import pay from '../views/index/pay'


const routes = [
	{path: '/',redirect: '/welcome'},
	{
		path: '/welcome',
		name: 'welcome',
		component: welcome,
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/hosts',
		children:[
			{
				path: '/hosts',
				name: 'hostIndex',
				component: hostIndex,
				meta: {
					title: '云数据库 RDS MySQL'
				}
			},
			{
				path: '/hosts/detail',
				name: 'hostDetail',
				component: hostDetail,
				meta: {
					title: '云数据库 RDS MySQL 详情'
				}
			},
			{
				path: '/hosts/delay',
				name: 'delay',
				component: delay,
				meta: {
					title: '云数据库 RDS MySQL 续费'
				}
			},
			{
				path: '/hosts/upgrade',
				name: 'upgrade',
				component: upgrade,
				meta: {
					title: '升级配置'
				}
			},
			{
				path: '/config',
				name: 'config',
				component: config,
				meta: {
					title: '参数模板设置'
				}
			}
		],
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/template',
		children:[
			{
				path: '/template',
				name: 'template',
				component: template,
				meta: {
					title: '参数管理'
				}
			},
			{
				path: '/template/detail',
				name: 'templateDetail',
				component: templateDetail,
				meta: {
					title: '参数模板详情'
				}
			},
		],
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/users',
		name: 'users',
		component: users,
		meta: {
			keepAlive: true,
			title: '用户管理'
		}
	},
	{
		path: '/warning',
		name: 'warning',
		component: warning,
		meta: {
			keepAlive: true,
			title: '预警推送'
		}
	},
	{
		path: '/backup',
		name: 'backup',
		component: backup,
		meta: {
			keepAlive: true,
			title: '备份管理'
		}
	},
	{
		path: '/lists',
		name: 'lists',
		component: lists,
		meta: {
			keepAlive: true,
			title: '白名单'
		}
	},
	{
		path: '/log',
		name: 'log',
		component: log,
		meta: {
			keepAlive: true,
			title: '操作审计'
		}
	},
	{
		path: '/pay',
		name: 'pay',
		component: pay
	}
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
	const store = useStore()
	const location = window.location.origin
	const reurl = encodeURIComponent(location + '/' + to.href)
	const domain = inject('domain');
	const accountDomain = inject('accountDomain');
	if(to.href.includes('#/pay')){
		next()
	}else{
		apiGetUserInfo().then((res) => {
			if(res.code === 200){
				const userName = res.data.user_info.truename == '' ? res.data.user_info.username : res.data.user_info.truename;
				store.commit("setUserName", userName)
				store.commit("setMenuName", 'rds')
				localStorage.setItem('smsPhone', res.data.user_info.phone);
				if (res.data.activate) {
					store.commit("setActivate", 'true')
					if (to.name == 'welcome') {
						next({ path: '/hosts' })
					} else { 
						next()
					}
				} else {
					if (to.name == 'welcome') {
						next();
					} else { 
						next({ path: '/welcome' })
					}
				}
				if (!res.data.real_name_status.is_auth){
					ElMessageBox.confirm(
						'依据国家法律法规，请您先进行实名认证!',
						'提示',
						{
							confirmButtonText: '确定',
							showCancelButton: false,
							closeOnClickModal: false,
							showClose:false,
							type: 'warning',
						}
					)
					.then(() => {
						window.location.href = domain + "/user/verifynew/reselect.html";
					})
				}
			}else{
				window.location.href = accountDomain + "/login?reurl=" + reurl;
			}
		})
	}
});

export default router